import { TextField, TextFieldProps } from "@mui/material";

const CustomTextField: React.FC<TextFieldProps> = (props) => {
  return (
    <TextField
      {...props}
      sx={{
        ...props.sx,
        backgroundColor: "#fff",
        borderRadius: "12px",
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff",
          borderRadius: "12px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#C79A61",
          borderRadius: "12px",
        },
        "& input:-webkit-autofill": {
          boxShadow: "0 0 0 1000px #fff inset !important",
          WebkitTextFillColor: "#000",
          borderRadius: "12px",
        },
      }}
    />
  );
};

export default CustomTextField;
